import type { FaireProductEntity } from "../../entity_types/product";

export const atc_refined_moma_10: FaireProductEntity = {
  token: "atc_refined_moma_10",
  type: "product",
  name: "Modern Coffee Service Set",
  brandName: "Pozzi Milano",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/f870daf6e2d555e321ff766d6109dbebe8e2b6af1139b38d8801caac84c91f92.webp",
  priceDollars: 52,
  msrpDollars: 84,
  description: "Italian-designed tableware with Memphis-inspired aesthetic.",
  tags: ["tableware", "drinkware", "design"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "atc-entity-migration",
  },
};
